<div class="lead-campaign">
  <app-lead-card id="Y56T-KIJ90k-HG84" [dashboard]="mock_dashboard" routerParams="lista" (routerActived)="routerActived($event)">
  </app-lead-card>
  <app-faq></app-faq>
</div>